// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inquiries-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.inquiries-container .inquiry-type {
  display: flex;
  align-items: center;
}
.inquiries-container .inquiry-type > li {
  position: relative;
  width: 120px;
  -webkit-user-select: none;
          user-select: none;
}
.inquiries-container .inquiry-type > li > p {
  font-size: 12px;
  font-weight: 500;
  color: #5F5F5F;
  margin: 0;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  padding: 16px;
  transition: 0.2 ease-in-out;
}
.inquiries-container .inquiry-type > li > p:hover {
  opacity: 0.75;
}
.inquiries-container .inquiry-type > li::before {
  content: "";
  position: absolute;
  height: 4px;
  width: 100%;
  border-radius: 2px;
  background-color: white;
  bottom: -5px;
  transition: 0.3s ease-in-out;
}
.inquiries-container .inquiry-type > li.active > p {
  font-weight: 700;
  color: var(--primary-color-1);
}
.inquiries-container .inquiry-type > li.active::before {
  background-color: var(--primary-color-1);
}
.inquiries-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
  display: flex;
  position: relative;
}
.inquiries-container .contents .table-container {
  overflow: auto;
  width: 100%;
}
.inquiries-container .contents .table-container .body {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.inquiries-container .contents .table-container .body.resolved td {
  background-color: #F4F7FA;
  color: #949494;
}
.inquiries-container .contents .table-container .body:hover {
  opacity: 0.75;
}
.inquiries-container .contents .table-container::-webkit-scrollbar {
  width: 3px;
}
.inquiries-container .contents .table-container::-webkit-scrollbar-track {
  background: #fff;
}
.inquiries-container .contents .table-container::-webkit-scrollbar-thumb {
  background-color: #C9C9C9;
  border-radius: 6px;
  border: none;
}
.inquiries-container .contents .table-container .message {
  max-width: 500px;
}
.inquiries-container .contents .table-container .message > p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 600;
  color: #5F5F5F;
  margin: 0;
}
.inquiries-container .contents .preview-inquiry {
  width: 100%;
  padding: 16px 24px;
  height: calc(100vh - 140px);
  background-color: white;
  max-width: 300px;
  border-left: 1px solid #E4E4E4;
}
.inquiries-container .contents .preview-inquiry .selected-inquiry {
  animation: fadein 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.inquiries-container .contents .preview-inquiry .mobile-close {
  display: none;
}
.inquiries-container .contents .preview-inquiry .title {
  font-size: 14px;
  margin: 0;
  font-weight: 700;
  color: var(--secondary-color-1);
  text-transform: capitalize;
}
.inquiries-container .contents .preview-inquiry .subtitle {
  font-size: 12px;
  color: #949494;
  font-weight: 500;
}
.inquiries-container .contents .preview-inquiry .actions svg {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.inquiries-container .contents .preview-inquiry .actions svg:hover {
  opacity: 0.75;
}
.inquiries-container .contents .preview-inquiry .listing-card {
  padding: 8px;
  border-radius: 16px;
  display: flex;
  background-color: #F9F9F9;
  column-gap: 16px;
  align-items: center;
}
.inquiries-container .contents .preview-inquiry .listing-card img {
  width: 40px;
  border-radius: 8px;
  height: 40px;
  object-fit: cover;
}
.inquiries-container .contents .preview-inquiry .listing-card > div {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  max-width: 150px;
}
.inquiries-container .contents .preview-inquiry .listing-card > div .name {
  margin: 0;
  font-weight: 600;
  font-size: 14px;
}
.inquiries-container .contents .preview-inquiry .listing-card > div .address {
  font-size: 12px;
  font-weight: 400;
  color: #5F5F5F;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
}
.inquiries-container .contents .preview-inquiry .requestor {
  display: flex;
  column-gap: 8px;
  align-items: center;
}
.inquiries-container .contents .preview-inquiry .requestor img {
  width: 32px;
  border-radius: 100%;
  height: 32px;
  object-fit: cover;
}
.inquiries-container .contents .preview-inquiry .requestor > div {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}
.inquiries-container .contents .preview-inquiry .requestor > div p {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}
.inquiries-container .contents .preview-inquiry .requestor > div span {
  font-size: 12px;
  font-weight: 400;
  color: #949494;
}
.inquiries-container .contents .preview-inquiry .inquiry-status {
  border-radius: 8px;
  padding: 6px 8px;
  font-weight: 800;
  font-size: 10px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0;
}
.inquiries-container .contents .preview-inquiry .inquiry-status.pending {
  color: #0097A1;
  background-color: #CCEAEC;
}
.inquiries-container .contents .preview-inquiry .inquiry-status.resolved {
  color: #10B980;
  background-color: #ECFDF5;
}
.inquiries-container .contents .preview-inquiry .inquiry-status.notified {
  color: #B15DD9;
  background-color: #EFDFF7;
}
.inquiries-container .pagination {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.inquiries-container .pagination > p {
  cursor: pointer;
  font-family: "Proxima Nova", sans-serif;
  font-size: 12px;
  font-weight: 760;
  color: #949494;
}
.inquiries-container .pagination > p:hover {
  opacity: 0.75;
}
.inquiries-container .pagination > p.next {
  text-align: right;
}
.inquiries-container .pagination > ul {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
}
.inquiries-container .pagination > ul > li {
  cursor: pointer;
  font-weight: 700;
  color: var(--secondary-color-3);
  font-size: 18px;
}
.inquiries-container .pagination > ul > li:hover {
  opacity: 0.75;
}
.inquiries-container .pagination > ul > li.active {
  color: var(--secondary-color-1);
  text-decoration: underline;
}
.inquiries-container .loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.863);
  z-index: 2;
  display: flex;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .inquiries-container .contents .table-container .message {
    max-width: 60vw;
  }
  .inquiries-container .contents .preview-inquiry {
    position: fixed;
    right: -310px;
    transition: 0.8s ease-in-out;
    opacity: 0;
  }
  .inquiries-container .contents .preview-inquiry .mobile-close {
    position: absolute;
    left: -5px;
    top: 0px;
    display: block;
    transition: 0.2s ease-in-out;
  }
  .inquiries-container .contents .preview-inquiry .mobile-close:hover {
    opacity: 0.75;
  }
  .inquiries-container .contents .preview-inquiry.show {
    opacity: 1;
    right: 0;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .inquiries-container .contents .table-container .message {
    max-width: 60vw;
  }
  .inquiries-container .contents .preview-inquiry {
    position: fixed;
    right: -310px;
    transition: 0.8s ease-in-out;
    opacity: 0;
  }
  .inquiries-container .contents .preview-inquiry .mobile-close {
    position: absolute;
    left: -5px;
    top: 0px;
    display: block;
    transition: 0.2s ease-in-out;
  }
  .inquiries-container .contents .preview-inquiry .mobile-close:hover {
    opacity: 0.75;
  }
  .inquiries-container .contents .preview-inquiry.show {
    opacity: 1;
    right: 0;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .inquiries-container .inquiry-type {
    justify-content: center;
    width: auto;
  }
  .inquiries-container .inquiry-type > li {
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    width: -moz-fit-content;
    width: fit-content;
    column-gap: 10px;
  }
  .inquiries-container .inquiry-type > li > p {
    padding: 10px;
  }
  .inquiries-container .contents .table-container .body {
    padding: 16px;
  }
  .inquiries-container .contents .table-container .body > td {
    width: 100% !important;
    text-align: left;
    padding: 0px;
  }
  .inquiries-container .contents .table-container .body > td p {
    padding: 0 16px;
  }
  .inquiries-container .contents .table-container .body .message {
    max-width: 90vw;
    width: 100%;
  }
  .inquiries-container .contents .table-container .body .message > p {
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/Inquiries/inquiries.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAGQ;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AADZ;AAGY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,2BAAA;AADhB;AAGgB;EACI,aAAA;AADpB;AAKY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,4BAAA;AAHhB;AAOgB;EACI,gBAAA;EACA,6BAAA;AALpB;AAQgB;EACI,wCAAA;AANpB;AAYI;EACI,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;AAVR;AAYQ;EACI,cAAA;EACA,WAAA;AAVZ;AAYY;EACI,eAAA;EACA,4BAAA;AAVhB;AAYoB;EACI,yBAAA;EACA,cAAA;AAVxB;AAagB;EACI,aAAA;AAXpB;AAeY;EACI,UAAA;AAbhB;AAgBY;EACI,gBAAA;AAdhB;AAiBY;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AAfhB;AAkBY;EACI,gBAAA;AAhBhB;AAkBgB;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAhBpB;AAqBQ;EACI,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,8BAAA;AAnBZ;AAqBY;EACI,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAnBhB;AAsBY;EACI,aAAA;AApBhB;AAuBY;EACI,eAAA;EACA,SAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;AArBhB;AAwBY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAtBhB;AA0BgB;EACI,eAAA;EACA,4BAAA;AAxBpB;AA0BoB;EACI,aAAA;AAxBxB;AA6BY;EACI,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AA3BhB;AA6BgB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA3BpB;AA8BgB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AA5BpB;AA8BoB;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AA5BxB;AA+BoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AA7BxB;AAmCY;EACI,aAAA;EACA,eAAA;EACA,mBAAA;AAjChB;AAkCgB;EACI,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAhCpB;AAkCgB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAhCpB;AAiCoB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AA/BxB;AAiCoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AA/BxB;AAoCY;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,SAAA;AAlChB;AAoCgB;EACI,cAAA;EACA,yBAAA;AAlCpB;AAqCgB;EACI,cAAA;EACA,yBAAA;AAnCpB;AAsCgB;EACI,cAAA;EACA,yBAAA;AApCpB;AA2CI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAzCR;AA0CQ;EACI,eAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxCZ;AAyCY;EAAU,aAAA;AAtCtB;AAuCY;EAAS,iBAAA;AApCrB;AAsCQ;EACI,aAAA;EACA,uCAAA;AApCZ;AAqCY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAnChB;AAoCgB;EAAU,aAAA;AAjC1B;AAkCgB;EACI,+BAAA;EACA,0BAAA;AAhCpB;AAsCI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,aAAA;AApCR;;AChPY;ED4RI;IACI,eAAA;EAxClB;EA4CU;IACI,eAAA;IACA,aAAA;IACA,4BAAA;IACA,UAAA;EA1Cd;EA4Cc;IACI,kBAAA;IACA,UAAA;IACA,QAAA;IACA,cAAA;IACA,4BAAA;EA1ClB;EA4CkB;IACI,aAAA;EA1CtB;EA8Cc;IACI,UAAA;IACA,QAAA;EA5ClB;AACF;ACjRY;EDmSI;IACI,eAAA;EAflB;EAmBU;IACI,eAAA;IACA,aAAA;IACA,4BAAA;IACA,UAAA;EAjBd;EAmBc;IACI,kBAAA;IACA,UAAA;IACA,QAAA;IACA,cAAA;IACA,4BAAA;EAjBlB;EAmBkB;IACI,aAAA;EAjBtB;EAqBc;IACI,UAAA;IACA,QAAA;EAnBlB;AACF;AC1SY;EDqUJ;IACI,uBAAA;IACA,WAAA;EAxBV;EA0BU;IACI,kBAAA;IACA,yBAAA;YAAA,iBAAA;IACA,uBAAA;IAAA,kBAAA;IACA,gBAAA;EAxBd;EAyBc;IACI,aAAA;EAvBlB;EA8Bc;IACI,aAAA;EA5BlB;EA8BkB;IACI,sBAAA;IACA,gBAAA;IACA,YAAA;EA5BtB;EA8BsB;IACI,eAAA;EA5B1B;EAiCkB;IACI,eAAA;IACA,WAAA;EA/BtB;EAiCsB;IACI,0BAAA;EA/B1B;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.inquiries-container {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    font-family: \"Proxima Nova\", sans-serif;\r\n\r\n    .inquiry-type {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        >li {\r\n            position: relative;\r\n            width: 120px;\r\n            user-select: none;\r\n\r\n            >p {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                color: #5F5F5F;\r\n                margin: 0;\r\n                cursor: pointer;\r\n                width: fit-content;\r\n                padding: 16px;\r\n                transition: .2 ease-in-out;\r\n\r\n                &:hover {\r\n                    opacity: .75;\r\n                }\r\n            }\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                height: 4px;\r\n                width: 100%;\r\n                border-radius: 2px;\r\n                background-color: white;\r\n                bottom: -5px;\r\n                transition: .3s ease-in-out;\r\n            }\r\n\r\n            &.active {\r\n                >p {\r\n                    font-weight: 700;\r\n                    color: var(--primary-color-1);\r\n                }\r\n\r\n                &::before {\r\n                    background-color: var(--primary-color-1);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .contents {\r\n        margin-top: 60px;\r\n        max-height: calc(100vh - 140px);\r\n        display: flex;\r\n        position: relative;\r\n\r\n        .table-container {\r\n            overflow: auto;\r\n            width: 100%;\r\n\r\n            .body {\r\n                cursor: pointer;\r\n                transition: .2s ease-in-out;\r\n                &.resolved {\r\n                    td {\r\n                        background-color: #F4F7FA;\r\n                        color: #949494;\r\n                    }\r\n                }\r\n                &:hover {\r\n                    opacity: .75;\r\n                }\r\n            }\r\n\r\n            &::-webkit-scrollbar {\r\n                width: 3px;\r\n            }\r\n\r\n            &::-webkit-scrollbar-track {\r\n                background: #fff;\r\n            }\r\n\r\n            &::-webkit-scrollbar-thumb {\r\n                background-color: #C9C9C9;\r\n                border-radius: 6px;\r\n                border: none;\r\n            }\r\n\r\n            .message {\r\n                max-width: 500px;\r\n\r\n                >p {\r\n                    white-space: nowrap;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    font-size: 12px;\r\n                    font-weight: 600;\r\n                    color: #5F5F5F;\r\n                    margin: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .preview-inquiry {\r\n            width: 100%;\r\n            padding: 16px 24px;\r\n            height: calc(100vh - 140px);\r\n            background-color: white;\r\n            max-width: 300px;\r\n            border-left: 1px solid #E4E4E4;\r\n\r\n            .selected-inquiry {\r\n                animation: fadein .5s ease-in-out;\r\n                display: flex;\r\n                flex-direction: column;\r\n                justify-content: space-between;\r\n                height: 100%;\r\n            }\r\n\r\n            .mobile-close {\r\n                display: none;\r\n            }\r\n\r\n            .title {\r\n                font-size: 14px;\r\n                margin: 0;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n                text-transform: capitalize;\r\n            }\r\n\r\n            .subtitle {\r\n                font-size: 12px;\r\n                color: #949494;\r\n                font-weight: 500;\r\n            }\r\n\r\n            .actions {\r\n                svg {\r\n                    cursor: pointer;\r\n                    transition: .2s ease-in-out;\r\n\r\n                    &:hover {\r\n                        opacity: .75;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .listing-card {\r\n                padding: 8px;\r\n                border-radius: 16px;\r\n                display: flex;\r\n                background-color: #F9F9F9;\r\n                column-gap: 16px;\r\n                align-items: center;\r\n\r\n                img {\r\n                    width: 40px;\r\n                    border-radius: 8px;\r\n                    height: 40px;\r\n                    object-fit: cover;\r\n                }\r\n\r\n                >div {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 8px;\r\n                    max-width: 150px;\r\n\r\n                    .name {\r\n                        margin: 0;\r\n                        font-weight: 600;\r\n                        font-size: 14px;\r\n                    }\r\n\r\n                    .address {\r\n                        font-size: 12px;\r\n                        font-weight: 400;\r\n                        color: #5F5F5F;\r\n                        white-space: nowrap;\r\n                        overflow: hidden;\r\n                        margin: 0;\r\n                        text-overflow: ellipsis;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n            .requestor {\r\n                display: flex;\r\n                column-gap: 8px;\r\n                align-items: center;\r\n                img {\r\n                    width: 32px;\r\n                    border-radius: 100%;\r\n                    height: 32px;\r\n                    object-fit: cover;\r\n                }\r\n                > div {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 4px;\r\n                    p {\r\n                        margin: 0;\r\n                        font-size: 12px;\r\n                        font-weight: 600;\r\n                    }\r\n                    span {\r\n                        font-size: 12px;\r\n                        font-weight: 400;\r\n                        color: #949494;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .inquiry-status {\r\n                border-radius: 8px;\r\n                padding: 6px 8px;\r\n                font-weight: 800;\r\n                font-size: 10px;\r\n                width: fit-content;\r\n                margin: 0;\r\n\r\n                &.pending {\r\n                    color: #0097A1;\r\n                    background-color: #CCEAEC;\r\n                }\r\n\r\n                &.resolved {\r\n                    color: #10B980;\r\n                    background-color: #ECFDF5;\r\n                }\r\n\r\n                &.notified {\r\n                    color: #B15DD9;\r\n                    background-color: #EFDFF7;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .pagination {\r\n        display: flex;\r\n        align-items: center;\r\n        column-gap: 16px;\r\n        > p {\r\n            cursor: pointer;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            font-size: 12px;\r\n            font-weight: 760;\r\n            color: #949494;\r\n            &:hover { opacity: .75; }\r\n            &.next { text-align: right; }\r\n        }\r\n        > ul {\r\n            display: flex;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            > li { \r\n                cursor: pointer;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-3);\r\n                font-size: 18px;\r\n                &:hover { opacity: .75; }\r\n                &.active {\r\n                    color: var(--secondary-color-1);\r\n                    text-decoration: underline;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .loader {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        background-color: rgba(255, 255, 255, 0.863);\r\n        z-index: 2;\r\n        display: flex;\r\n    }\r\n}\r\n\r\n@include media(tablet, mobile) {\r\n    .inquiries-container {\r\n        .contents {\r\n            .table-container {\r\n                .message {\r\n                    max-width: 60vw;\r\n                }\r\n            }\r\n\r\n            .preview-inquiry {\r\n                position: fixed;\r\n                right: -310px;\r\n                transition: .8s ease-in-out;\r\n                opacity: 0;\r\n\r\n                .mobile-close {\r\n                    position: absolute;\r\n                    left: -5px;\r\n                    top: 0px;\r\n                    display: block;\r\n                    transition: .2s ease-in-out;\r\n\r\n                    &:hover {\r\n                        opacity: .75;\r\n                    }\r\n                }\r\n\r\n                &.show {\r\n                    opacity: 1;\r\n                    right: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .inquiries-container {\r\n        .inquiry-type {\r\n            justify-content: center;\r\n            width: auto;\r\n\r\n            >li {\r\n                position: relative;\r\n                user-select: none;\r\n                width: fit-content;\r\n                column-gap: 10px;\r\n                > p {\r\n                    padding: 10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .contents {\r\n            .table-container {\r\n                .body {\r\n                    padding: 16px;\r\n\r\n                    >td {\r\n                        width: 100% !important;\r\n                        text-align: left;\r\n                        padding: 0px;\r\n\r\n                        p {\r\n                            padding: 0 16px;\r\n                        }\r\n\r\n                    }\r\n\r\n                    .message {\r\n                        max-width: 90vw;\r\n                        width: 100%;\r\n\r\n                        >p {\r\n                            font-size: 14px !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
